'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */

import React, { useState } from 'react'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { fetchWidgetProductFn, widgetJourney } from '@configs/segmentEvents.config'
import { TAP_BTN_ENGAGE } from '@constants/homeSegmentEvent'
import DesktopChallanCard, { type ChallanListItem } from './DesktopChallanCard'
import styles from './DesktopChallanPPED.module.scss'

type DesktopChallanListProps = {
  challanList: ChallanListItem[]
  onViewAllChallans?: () => void
  segmentEventCommonProperties?: any
  widgetType: string
  vehicleInfoData?: any
}

const DesktopChallanList = ({
  challanList,
  onViewAllChallans,
  segmentEventCommonProperties,
  widgetType,
  vehicleInfoData,
}: DesktopChallanListProps) => {
  const [showAllChallans, setShowAllChallans] = useState(false)
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null)
  const visibleChallans = showAllChallans ? challanList : challanList.slice(0, 2)
  const canViewAll = !showAllChallans && challanList.length > 2

  const handleViewAll = () => {
    trackEvent(TAP_BTN_ENGAGE, {
      ...segmentEventCommonProperties,
      journey: widgetJourney?.[widgetType],
      product: fetchWidgetProductFn?.[widgetType]?.(),
      phone: vehicleInfoData?.mobile_number || '',
      registration_number: vehicleInfoData?.reg_number || '',
      cta_text: 'view_all_challans',
    })
    setShowAllChallans(true)
    onViewAllChallans?.()
  }

  return (
    <div className={`${styles.challanList} ${showAllChallans ? styles.challanListExpanded : ''}`}>
      <div className={styles.challanCards}>
        {visibleChallans.map((challan, index) => (
          <DesktopChallanCard
            key={`${challan.title}-${index}`}
            {...challan}
            isExpanded={expandedIndex === index}
            onToggleExpand={() => setExpandedIndex(previousIndex => (previousIndex === index ? null : index))}
          />
        ))}
      </div>
      {canViewAll && (
        <div
          role="button"
          tabIndex={0}
          className={styles.viewAllChallans}
          onClick={handleViewAll}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') handleViewAll()
          }}
        >
          View all challans
        </div>
      )}
      <div className={styles.gotChallansBanner}>
        <img src="https://acko-cms.ackoassets.com/Tax_c804cc8ab8.svg" />
        <div className={styles.gotChallansText}>
          <div className={styles.gotChallansTitle}>Got challans</div>
          <div>You can still save on car insurance.</div>
        </div>
      </div>
    </div>
  )
}

export default DesktopChallanList
